<template>
  <el-tag size="medium" :type="cssClass" v-if="status !== null">
    {{ statusLabel }}
  </el-tag>
</template>

<script>
  import constants from "../../constants";

  export default {
    name: "common-status-tag",
    props: ["status"],
    data() {
      return {
        cssClass: null,
        statusLabel: null
      };
    },
    watch: {
      status() {
        this.initComponent();
      }
    },
    created() {
      this.initComponent();
    },
    methods: {
      initComponent() {
        this.cssClass = this.initCssClass();
        this.statusLabel = this.initStatusLabel();
      },

      initCssClass() {
        switch (this.status) {
          case constants.TRUE:
            return "success";
          case constants.FALSE:
            return "danger";
          default:
            return "";
        }
      },

      initStatusLabel() {
        switch (this.status) {
          case constants.TRUE:
            return "Hoạt động";
          case constants.FALSE:
            return "Không hoạt động";
          default:
            return "";
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/common-status-tag.vue